import React, { useCallback, useEffect, useMemo } from 'react'
import { Row, Col, Space, Form } from 'antd'
import { LyricsInput } from 'components/LyricsInput'
import { KaraokeSlides } from 'components/KaraokeSlides'
import { Next } from 'components/BuildSteps/Next'
import { useLyricProcessor } from 'hooks/lyric'
import { useKaraoke } from 'hooks/karaoke'
import { KaraokeDetailsForm } from 'forms/KaraokeDetails'
import { useEventDispatch, _EVENTS } from 'utils/EventEmitter'

import './styles.scss'

export const _LYRIC_DESCRIPTION = `Lyric of the song here.

You can type double "ENTER" in order to create a new slide.`

export const PlaygroundPhase1 = (props) => {
  const { selectVerse, lyrics } = useLyricProcessor()
  const { dispatchEvent: changeVerse } = useEventDispatch(_EVENTS.VERSE_CHANGE)
  const { audio, metadata, setPlaygroud } = useKaraoke()
  const [form] = Form.useForm()

  const initialValues = useMemo(() => ({ ...metadata, audio }), [])

  const handleDetails = useCallback(
    ({ audio, ...metadata }) => {
      setPlaygroud({ audio, metadata, lyrics })
    },
    [lyrics]
  )

  return (
    <>
      <Row gutter={16}>
        <Col className="small-canvas">
          <KaraokeSlides onItemClick={changeVerse} />
        </Col>
        <Col flex={1}>
          <LyricsInput />
        </Col>
      </Row>

      <Row className="footer" align="middle" justify="center">
        <Col flex={1}>
          <Space direction="vertical">
            <KaraokeDetailsForm
              form={form}
              onFinish={handleDetails}
              initialValues={initialValues}
            />
          </Space>
        </Col>
        <Col>
          <Form.Item>
            <Next
              title="Sync Lyrics"
              // disabled={!has(audio, 'src')}
              htmlType="submit"
              onClick={form.submit}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
